import { gql } from "@apollo/client";

const GET_PRICE_MODELS = gql`
  query getPriceLists($companyId: Int!) {
    companyAdminContext {
      pricingModels {
        pricingModels(companyId: $companyId) {
				  id
				  name
				  description
        }
      }
    }
  }
`;

export default GET_PRICE_MODELS;